import { render, staticRenderFns } from "./StudentPicker.vue?vue&type=template&id=e3c9f5ec&"
import script from "./StudentPicker.vue?vue&type=script&lang=js&"
export * from "./StudentPicker.vue?vue&type=script&lang=js&"
import style0 from "./StudentPicker.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports